// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_HIDE_TERMS = "Skryj podm\u00ednky";
export const BZ2_SHOW_COMPLETE_TERMS = "Zobraz cel\u00e9 podm\u00ednky";
export const BZ2_USER_DETAILS_SHOW_PROFILE = "Profil u\u017eivatelky";
export const USER_LIKE = "P\u0159idej k obl\u00edben\u00fdm";
export const USER_UNLIKE = "Odeber z obl\u00edben\u00fdch";
